import { allMapsImageData, IMapImageData } from "@/utils/data"
import classNames from "classnames"
import { useEffect } from "react"
import PropertySmallCard from "./PropertySmallCard"
import { TradeScreenPropertyCardProps } from "../Trade/TradeScreenPropertyCard"

interface PropertiesSetProps {
  properties: ICell[]
  group: IPropertyGroup
  PropertCardComponent: React.FC<TradeScreenPropertyCardProps>
  forTradeScreen?: boolean
}
const PropertiesSet: React.FC<PropertiesSetProps> = ({
  properties,
  group,
  PropertCardComponent,
  forTradeScreen = false,
}) => {
  return (
    <div
      // On the trade screen the gap tracks the card size (see useFitTradeCards)
      // so a shrunken grid doesn't end up with gaps wider than its cards. The
      // fallback is the original `gap-2`.
      style={forTradeScreen ? { gap: "var(--tc-gap, 0.5rem)" } : undefined}
      className={classNames("flex ", {
        "gap-0.5": !forTradeScreen,
      })}
    >
      {[...properties]
        .sort((a, b) => a.order - b.order)
        .map((property, i) => {
          return (
            <PropertCardComponent
              key={
                property.order +
                (property.metadata?.dummySmallCard ? "-dummy" : "")
              }
              group={group}
              property={property}
            ></PropertCardComponent>
          )
        })}
    </div>
  )
}

export default PropertiesSet
